<template>
    <div class="file_form">
        <div class="file_wrapper">
            <div
                class="file_upload_block"
                style="margin-top: 0;"
                :class="{ 'is-invalid': error }"
            >
                <div class="icon_wrapper">
                    <picture v-full-image-path:assets="'file_icon.svg'" />
                </div>
                <div class="text_center">
                    <div v-if="filename">
                        נבחר :
                        {{ filename }}
                    </div>

                    <label class="file_btn file_upload_button">
                        <input
                            :id="question.label"
                            ref="fileInput"
                            type="file"
                            style="width: 100%"
                            @change="changeFile"
                        />
                        <div v-if="filename">
                            <div>
                                בחר חדש
                            </div>
                        </div>

                        <span v-else>
                            בחר/י קובץ
                        </span>
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        question: {
            type: Object,
            required: true
        },

        error: {
            type: Boolean,
            required: true
        }
    },

    data() {
        return {
            filename: ''
        };
    },

    methods: {
        changeFile() {
            if (!this.$refs.fileInput.files.length) {
                this.$emit('input', null);

                this.filename = '';

                return;
            }

            const [file] = this.$refs.fileInput.files;

            this.filename = file.name;

            this.$emit('input', file);
        }
    }
};
</script>
